module.exports = __webpack_public_path__ + "img/share.5dc7432d.png";